import React from 'react';

export interface FeeAmountLoadingProps {
  /** `lg` matches the large desktop fee amount; `sm` the footer fee row. */
  size?: 'sm' | 'lg';
}

/** Placeholder shown in place of the fee while the server quote loads. */
const FeeAmountLoading = ({ size = 'sm' }: FeeAmountLoadingProps) => (
  <span
    role="status"
    className={`inline-block align-middle rounded-md bg-slate-200 animate-pulse ${
      size === 'lg' ? 'h-8 w-32' : 'h-5 w-20'
    }`}
  >
    <span className="sr-only">Loading fee…</span>
  </span>
);

export default FeeAmountLoading;
